///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { StaticContentDTO } from '../../../generated/shared-types.model';
import { GtthReleaseNotesLimitation } from './release-note-items/release-notes-limitation.model';
import { ExtendedStaticContent } from './extended-static-content.model';

export class LimitationStaticContent implements ExtendedStaticContent {
    public readonly TITLE_TRANSLATION_PATH = 'global.menu.help.releaseNotes.limitationsAndKnownIssues';
    public readonly TOOLTIP_TRANSLATION_PATH = 'releaseNotes.addLimitation';
    public id: number;
    public type: string;
    public content: GtthReleaseNotesLimitation[];

    constructor(data: StaticContentDTO) {
        this.id = data.id;
        this.type = data.type;
        this.content = data.content.map((item) => new GtthReleaseNotesLimitation(item.topic, item.limitation, item.notes));
    }

    getPlainObject(): StaticContentDTO {
        return {
            id: this.id,
            type: this.type,
            content: this.content.map((item: GtthReleaseNotesLimitation) => item.getPlainObject())
        };
    }

    getTitleTranslationPath() {
        return this.TITLE_TRANSLATION_PATH;
    }

    getTooltipTranslationPath() {
        return this.TOOLTIP_TRANSLATION_PATH;
    }

    update(item: any): GtthReleaseNotesLimitation {
        return new GtthReleaseNotesLimitation(item?.topic, item?.limitation, item?.notes);
    }
}
